/* * (c) 2026 ZebraTransfers. All rights reserved.
 * Unauthorized copying, distribution or modification of this code
 * is strictly prohibited. Zebra-Engine V1.1 - Proprietary Technology.
 */

(function() { // Sicherheits-Käfig START

let uploadLiftField = null;

function initUploadLift(field) {
    uploadLiftField = field;
    console.log("Zebra-Check: UploadLift Field erfolgreich verknüpft!", field);
}

// Hilfsfunktion: Sucht UploadLift auch nachträglich, falls LPO langsamer lädt
function getOrInitUploadLift() {
    if (uploadLiftField) return uploadLiftField;
    if (window.UploadLift && window.UploadLift.fields) {
        const fields = Object.values(window.UploadLift.fields);
        if (fields.length > 0) {
            initUploadLift(fields[0]);
            return uploadLiftField;
        }
    }
    return null;
}

window.addEventListener('upload:ready', function(e) {
    initUploadLift(e.detail);
});

setTimeout(getOrInitUploadLift, 1500);
setTimeout(getOrInitUploadLift, 3500);

document.addEventListener("DOMContentLoaded", () => {
    const WORKER_URL = "https://aged-cloud-56ac.yasberkaymak.workers.dev"; 

    // --- DOM ELEMENTE SAMMELN ---
    const fileInput = document.getElementById('file-upload-input');
    const uploadBox = document.getElementById('upload-state');
    const configuratorState = document.getElementById('configurator-state');
    const canvas = document.getElementById('preview-canvas');
    const ctx = canvas.getContext('2d');
    const loader = document.getElementById('canvas-loader');
    const resetBtn = document.getElementById('reset-btn');
    
    const inputWidth = document.getElementById('input-width');
    const inputHeight = document.getElementById('input-height');
    const inputQty = document.getElementById('input-qty');
    const qtyDisplay = document.getElementById('qty-display');
    const labelWidth = document.querySelector('#label-width span');
    const labelHeight = document.querySelector('#label-height span');

    const viewToggle = document.getElementById('view-toggle');
    const previewColumn = document.querySelector('.preview-column');

    const removeBgBtn = document.getElementById('ai-remove-bg-btn'); 
    const upscaleBtn = document.getElementById('ai-upscale-btn');
    
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    const addAndResetBtn = document.getElementById('add-and-reset-btn');
    const widthMinusBtn = document.querySelector('#ctrl-width .minus');
    const widthPlusBtn = document.querySelector('#ctrl-width .plus');
    const heightMinusBtn = document.querySelector('#ctrl-height .minus');
    const heightPlusBtn = document.querySelector('#ctrl-height .plus');
    const qtyMinusBtn = document.getElementById('qty-minus');
    const qtyPlusBtn = document.getElementById('qty-plus');

    let aiCache = {
        original: null,
        bgOnly: null,
        upOnly: null,
        both: null
    };
    
    let currentImage = new Image();
    let imageAspectRatio = 1;
    let isProcessing = false; 

    if (inputWidth) inputWidth.value = "8.0";
    if (inputQty) inputQty.value = 1;
    if (qtyDisplay) qtyDisplay.innerText = "1";

    // --- BILD-UPLOAD LOGIK ---
    document.addEventListener('click', (e) => {
        const uBox = e.target.closest('#upload-state');
        if (uBox) {
            isProcessing = false;
            const freshFileInput = document.getElementById('file-upload-input');
            if (freshFileInput) freshFileInput.click();
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target && e.target.id === 'file-upload-input') {
            if (e.target.files.length > 0) {
                handleFile(e.target.files[0]);
            }
            e.target.value = ''; 
        }
    });

    document.addEventListener('dragover', (e) => {
        const uBox = e.target.closest('#upload-state');
        if (uBox) { 
            e.preventDefault(); 
            uBox.style.borderColor = '#0284c7'; 
            uBox.style.background = '#e0f2fe'; 
        }
    });
    
    document.addEventListener('dragleave', (e) => {
        const uBox = e.target.closest('#upload-state');
        if (uBox) { 
            uBox.style.borderColor = ''; 
            uBox.style.background = ''; 
        }
    });
    
    document.addEventListener('drop', (e) => {
        const uBox = e.target.closest('#upload-state');
        if (uBox) {
            e.preventDefault();
            uBox.style.borderColor = ''; 
            uBox.style.background = '';
            if (e.dataTransfer.files.length > 0) handleFile(e.dataTransfer.files[0]);
        }
    });

    function handleFile(file) {
        isProcessing = false;
        const MAX_SIZE = 10 * 1024 * 1024; 
        if (file.size > MAX_SIZE) {
            alert("⚠️ Datei zu groß!\n Erlaubt sind maximal 10 MB für ein Motiv.");
            return; 
        }
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                aiCache.original = img;
                aiCache.bgOnly = null;
                aiCache.upOnly = null;
                aiCache.both = null;
                
                const freshBgBtn = document.getElementById('ai-remove-bg-btn');
                const freshUpBtn = document.getElementById('ai-upscale-btn');
                if(freshBgBtn) freshBgBtn.checked = false;
                if(freshUpBtn) freshUpBtn.checked = false;
                
                currentImage = img;
                processImage(currentImage);
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    }

    // --- OPTIMIERTE BILDVERARBEITUNG ---
    function processImage(img) {
        const analysisScale = Math.min(1, 800 / Math.max(img.width, img.height));
        const analysisW = Math.round(img.width * analysisScale);
        const analysisH = Math.round(img.height * analysisScale);

        const tempCanvas = document.createElement('canvas');
        const tempCtx = tempCanvas.getContext('2d', { willReadFrequently: true });
        tempCanvas.width = analysisW;
        tempCanvas.height = analysisH;
        tempCtx.drawImage(img, 0, 0, analysisW, analysisH);

        const imageData = tempCtx.getImageData(0, 0, analysisW, analysisH);
        const data = imageData.data;
        const w = analysisW;
        const h = analysisH;

        let minX = w, minY = h, maxX = 0, maxY = 0;
        let foundContent = false;

        const isTransparentPNG = (data[3] < 50) && (data[((w-1) * 4) + 3] < 50);

        if (isTransparentPNG) {
            for (let y = 0; y < h; y++) {
                for (let x = 0; x < w; x++) {
                    if (data[(y * w + x) * 4 + 3] > 20) { 
                        foundContent = true;
                        if (x < minX) minX = x; if (x > maxX) maxX = x;
                        if (y < minY) minY = y; if (y > maxY) maxY = y;
                    }
                }
            }
        } else {
            const mask = new Uint8Array(w * h);
            const tolerance = 80;
            const refR = data[0], refG = data[1], refB = data[2];
            const stack = [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]];
            
            while (stack.length > 0) {
                const [x, y] = stack.pop();
                const idx = y * w + x;
                
                if (x >= 0 && x < w && y >= 0 && y < h && mask[idx] === 0) {
                    const i = idx * 4;
                    const diff = Math.abs(data[i] - refR) + Math.abs(data[i+1] - refG) + Math.abs(data[i+2] - refB);
                    if (diff < tolerance || data[i+3] < 50) {
                        mask[idx] = 1; 
                        stack.push([x + 1, y], [x - 1, y], [x, y + 1], [x, y - 1]);
                    }
                }
            }
            for (let i = 0; i < mask.length; i++) {
                if (mask[i] === 0) {
                    foundContent = true;
                    const x = i % w;
                    const y = Math.floor(i / w);
                    if (x < minX) minX = x; if (x > maxX) maxX = x;
                    if (y < minY) minY = y; if (y > maxY) maxY = y;
                }
            }
        }

        if (!foundContent) { minX = 0; minY = 0; maxX = w; maxY = h; }

        const p = 5;
        const scaleBack = 1 / analysisScale;
        const bounds = {
            x: Math.max(0, (minX * scaleBack) - p),
            y: Math.max(0, (minY * scaleBack) - p),
            w: Math.min(img.width - Math.max(0, (minX * scaleBack) - p), ((maxX - minX) * scaleBack) + (p * 2)),
            h: Math.min(img.height - Math.max(0, (minY * scaleBack) - p), ((maxY - minY) * scaleBack) + (p * 2))
        };

        canvas.width = bounds.w;
        canvas.height = bounds.h;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, bounds.x, bounds.y, bounds.w, bounds.h, 0, 0, bounds.w, bounds.h);

        const parentWidth = configuratorState.offsetWidth || window.innerWidth;
        const maxAvailableWidth = Math.min(350, parentWidth - 40); 
        const scale = Math.min(maxAvailableWidth / bounds.w, maxAvailableWidth / bounds.h);
        
        const wrapper = canvas.parentElement; 
        if (wrapper) {
            wrapper.style.display = "block"; 
            wrapper.style.width = Math.round(bounds.w * scale) + "px"; 
            wrapper.style.height = Math.round(bounds.h * scale) + "px";
        }

        checkTransparency(imageData, w, h); 
        uploadBox.style.display = 'none';
        configuratorState.style.display = 'flex';
        imageAspectRatio = bounds.h / bounds.w;
        updateFromWidth(); 
    }

    // --- AI BILDVERARBEITUNG ---
    async function processAI(type, cacheKey, isChained = false) {
        if (!currentImage || isProcessing) return;

        if (type === 'upscale' && (canvas.width * canvas.height > 1048576)) {
            alert("Dein Bild ist bereits groß. Ein zusätzliches Schärfen würde die erlaubte Dateigröße von 10 MB überschreiten. Dein Motiv bleibt daher im Originalzustand erhalten.");
            if(upscaleBtn) upscaleBtn.checked = false;
            applyAILogic(); 
            return;
        }
        
        isProcessing = true;
        if (loader) {
            loader.style.display = 'flex';
            const loadingText = document.getElementById('zebra-loading-text');
            if (loadingText) loadingText.innerText = (type === 'remove' ? "Hintergrund wird entfernt..." : "Bild wird geschärft...");
        }

        try {
            const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 1.0));
            const formData = new FormData();
            formData.append('image', blob, 'logo-buegelbild.png');

            const endpoint = type === 'remove' ? '/remove-bg' : '/upscale';
            const response = await fetch(WORKER_URL + endpoint, { method: 'POST', body: formData });

            if (!response.ok) {
                const errorMsg = await response.text();
                throw new Error(errorMsg.includes("unsupported dimensions") ? "Bild zu groß für diesen Schritt." : errorMsg);
            }

            const resultBlob = await response.blob();
            const newImg = new Image();
            
            return new Promise((resolve) => {
                newImg.onload = () => {
                    aiCache[cacheKey] = newImg;
                    if (!isChained) {
                        currentImage = newImg;
                        processImage(newImg); 
                        if (loader) loader.style.display = 'none';
                        isProcessing = false;
                    }
                    resolve(newImg);
                };
                newImg.src = URL.createObjectURL(resultBlob);
            });

        } catch (error) {
            alert("Hinweis: " + error.message); 
            if (loader) loader.style.display = 'none';
            isProcessing = false;
            
            if(type === 'remove') removeBgBtn.checked = false;
            if(type === 'upscale') upscaleBtn.checked = false;
            applyAILogic(); 
            throw error;
        } finally {
            if (!isChained) {
                isProcessing = false; 
                if (loader) loader.style.display = 'none';
            }
        }
    }

    if(removeBgBtn) removeBgBtn.addEventListener('change', () => applyAILogic());
    if(upscaleBtn) upscaleBtn.addEventListener('change', () => applyAILogic());

    // --- BERECHNUNG & SYNC (ZEBRA MASTER) ---
    function updateFromWidth() {
        let w = parseFloat(inputWidth.value.replace(',', '.')) || 8;
        if (w > 27) w = 27;
        if (w < 4) w = 4;
        
        let h = w * imageAspectRatio;
        const finalW = w.toFixed(1); 
        const finalH = h.toFixed(1);

        inputWidth.value = finalW;
        inputHeight.value = finalH;

        refreshUI(finalW, finalH);
    }

    function updateFromHeight() {
        let h = parseFloat(inputHeight.value.replace(',', '.')) || 8;
        let w = h / imageAspectRatio;

        if (w > 27) { w = 27; h = w * imageAspectRatio; }
        if (w < 4) { w = 4; h = w * imageAspectRatio; }
        
        const finalW = w.toFixed(1);
        const finalH = h.toFixed(1);

        inputWidth.value = finalW;
        inputHeight.value = finalH;
        
        refreshUI(finalW, finalH);
    }

    function refreshUI(w, h) {
        if(labelWidth) labelWidth.innerText = parseFloat(w).toFixed(1).replace('.', ',') + " cm";
        if(labelHeight) labelHeight.innerText = parseFloat(h).toFixed(1).replace('.', ',') + " cm";
        
        const dpi = Math.round((currentImage.width * 2.54) / parseFloat(w));
        const dpiPill = document.getElementById('pill-dpi');
        if (dpiPill) {
            if (dpi >= 175) { dpiPill.innerHTML = `✅ Auflösung (${dpi} DPI)`; dpiPill.style.color = "#22c55e"; }
            else if (dpi >= 75) { dpiPill.innerHTML = `⏳ Auflösung (${dpi} DPI)`; dpiPill.style.color = "#f59e0b"; }
            else { dpiPill.innerHTML = `❌ Auflösung (${dpi} DPI)`; dpiPill.style.color = "#ef4444"; }
        }
        
        const qty = parseInt(inputQty.value) || 1;
        syncToLiveProductOptions(w, h, qty);
        calculatePrice(parseFloat(w), parseFloat(h));
    }

    function calculatePrice(w, h) {
        const qty = parseInt(inputQty.value) || 1;
        const areaCm2 = w * h;
        
        const engineRoot = document.getElementById('zebra-engine-root');
        const shopifyBasePrice = parseFloat(engineRoot.dataset.productPrice) || 0;
        const areaSurcharge = (areaCm2 / 10000) * 64;

        let basePrice = Math.round((shopifyBasePrice + areaSurcharge) * 100) / 100;
        let priceTier1 = basePrice;
        let priceTier20 = Math.round((basePrice * 0.90) * 100) / 100;
        let priceTier50 = Math.round((basePrice * 0.80) * 100) / 100;

        const tier1Span = document.querySelector('#tier-1 .tier-price');
        const tier20Span = document.querySelector('#tier-20 .tier-price');
        const tier50Span = document.querySelector('#tier-50 .tier-price');

        if(tier1Span) tier1Span.innerText = priceTier1.toLocaleString('de-DE', {style:'currency', currency:'EUR'});
        if(tier20Span) tier20Span.innerText = priceTier20.toLocaleString('de-DE', {style:'currency', currency:'EUR'});
        if(tier50Span) tier50Span.innerText = priceTier50.toLocaleString('de-DE', {style:'currency', currency:'EUR'});

        let unitPrice = priceTier1;
        if (qty >= 50) unitPrice = priceTier50;
        else if (qty >= 20) unitPrice = priceTier20;
        
        document.getElementById('unit-price').innerText = unitPrice.toLocaleString('de-DE', {style:'currency', currency:'EUR'});
        document.getElementById('total-price').innerText = (unitPrice * qty).toLocaleString('de-DE', {style:'currency', currency:'EUR'});
        
        document.getElementById('tier-1').classList.remove('active');
        document.getElementById('tier-20').classList.remove('active');
        document.getElementById('tier-50').classList.remove('active');
        
        if (qty >= 50) document.getElementById('tier-50').classList.add('active'); 
        else if (qty >= 20) document.getElementById('tier-20').classList.add('active'); 
        else document.getElementById('tier-1').classList.add('active'); 
    }

    function checkTransparency(imageData, w, h) {
        const d = imageData.data;
        let transCount = 0;
        for (let i = 3; i < d.length; i += 4) { if (d[i] < 200) transCount++; }
        const transPill = document.getElementById('pill-transparency');
        if (transPill) {
            if ((transCount / (w * h) * 100) < 1) {
                transPill.innerHTML = `⚠️ Keine Transparenz`;
                transPill.style.color = "#f59e0b";
            } else {
                transPill.innerHTML = `✅ Transparenz`;
                transPill.style.color = "#22c55e";
            }
        }
    }

    async function applyAILogic() {
        if (isProcessing) return;

        const wantBg = removeBgBtn.checked;
        const wantUp = upscaleBtn.checked;

        if (!wantBg && !wantUp) {
            currentImage = aiCache.original;
            processImage(currentImage);
            return;
        }

        if (wantBg && !wantUp) {
            if (aiCache.bgOnly) {
                currentImage = aiCache.bgOnly;
                processImage(currentImage);
            } else {
                currentImage = aiCache.original;
                canvas.width = currentImage.width;
                canvas.height = currentImage.height;
                ctx.drawImage(currentImage, 0, 0);
                await processAI('remove', 'bgOnly', false);
            }
            return;
        }

        if (!wantBg && wantUp) {
            if (aiCache.upOnly) {
                currentImage = aiCache.upOnly;
                processImage(currentImage);
            } else {
                currentImage = aiCache.original;
                canvas.width = currentImage.width;
                canvas.height = currentImage.height;
                ctx.drawImage(currentImage, 0, 0);
                await processAI('upscale', 'upOnly', false);
            }
            return;
        }

        if (wantBg && wantUp) {
            if (aiCache.both) {
                currentImage = aiCache.both;
                processImage(currentImage);
                return;
            }

            try {
                if (!aiCache.upOnly) {
                    await processAI('upscale', 'upOnly', true);
                }
                isProcessing = false; 
                currentImage = aiCache.upOnly;
                canvas.width = currentImage.width;
                canvas.height = currentImage.height;
                ctx.drawImage(currentImage, 0, 0);

                await processAI('remove', 'both', false);
            } catch (e) {
                console.error("Zebra-Ketten-Fehler", e);
                isProcessing = false;
                if (loader) loader.style.display = 'none';
            }
            return;
        }
    }

    async function getSafeBlob(sourceCanvas, maxSizeMB = 9.5) {
        let blob = await new Promise(resolve => sourceCanvas.toBlob(resolve, 'image/png'));
        let maxBytes = maxSizeMB * 1024 * 1024;
        if (blob.size <= maxBytes) return blob;

        console.log(`Zebra-Sicherheit: Bild ist ${Math.round(blob.size/1024/1024)}MB. Verkleinere für Upload...`);
        let scale = Math.sqrt(maxBytes / blob.size) * 0.95;

        let tempCanvas = document.createElement('canvas');
        tempCanvas.width = sourceCanvas.width * scale;
        tempCanvas.height = sourceCanvas.height * scale;
        
        let tempCtx = tempCanvas.getContext('2d');
        tempCtx.drawImage(sourceCanvas, 0, 0, tempCanvas.width, tempCanvas.height);

        return await new Promise(resolve => tempCanvas.toBlob(resolve, 'image/png'));
    }

    // FIX: Feuert jetzt 'input' UND 'change' ab, damit LPO sofort live mitrechnet!
    function syncToLiveProductOptions(w, h, qty) {
        const lpoX = document.querySelector('input[name="properties[_Größe_x]"]');
        const lpoY = document.querySelector('input[name="properties[_Größe_y]"]');
        const lpoQty = document.querySelector('input[name="quantity"]');

        if (lpoQty && qty) {
            lpoQty.value = qty;
            lpoQty.dispatchEvent(new Event('input', { bubbles: true }));
            lpoQty.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (lpoX && lpoY) {
            lpoX.value = w.toString().replace('.', ',');
            lpoY.value = h.toString().replace('.', ',');
            lpoX.dispatchEvent(new Event('input', { bubbles: true }));
            lpoX.dispatchEvent(new Event('change', { bubbles: true }));
            lpoY.dispatchEvent(new Event('input', { bubbles: true }));
            lpoY.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    // --- EVENT LISTENERS FÜR BUTTONS ---
    if(widthPlusBtn) widthPlusBtn.addEventListener('click', () => {
        let current = parseFloat(inputWidth.value.replace(',', '.')) || 8;
        inputWidth.value = (current + 0.5).toFixed(1);
        updateFromWidth();
    });

    if(widthMinusBtn) widthMinusBtn.addEventListener('click', () => {
        let current = parseFloat(inputWidth.value.replace(',', '.')) || 8;
        inputWidth.value = (current - 0.5).toFixed(1);
        updateFromWidth();
    });

    if(heightPlusBtn) heightPlusBtn.addEventListener('click', () => {
        let current = parseFloat(inputHeight.value.replace(',', '.')) || 8;
        inputHeight.value = (current + 0.5).toFixed(1);
        updateFromHeight();
    });

    if(heightMinusBtn) heightMinusBtn.addEventListener('click', () => {
        let current = parseFloat(inputHeight.value.replace(',', '.')) || 8;
        inputHeight.value = (current - 0.5).toFixed(1);
        updateFromHeight();
    });

    if(qtyPlusBtn) qtyPlusBtn.addEventListener('click', () => { 
        let newQty = parseInt(inputQty.value) + 1;
        inputQty.value = newQty; 
        qtyDisplay.innerText = newQty; 
        updateFromWidth(); 
    });

    if(qtyMinusBtn) qtyMinusBtn.addEventListener('click', () => { 
        if (parseInt(inputQty.value) > 1) { 
            let newQty = parseInt(inputQty.value) - 1;
            inputQty.value = newQty; 
            qtyDisplay.innerText = newQty; 
            updateFromWidth(); 
        } 
    });

    inputWidth.addEventListener('input', updateFromWidth);
    inputHeight.addEventListener('input', updateFromHeight);

    resetBtn.addEventListener('click', () => {
        configuratorState.style.display = 'none';
        uploadBox.style.display = 'flex';
        aiCache = { original: null, bgOnly: null, upOnly: null, both: null };
        fileInput.value = ''; 
        inputWidth.value = "8.0";
        inputQty.value = 1;
        qtyDisplay.innerText = "1";
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    });

    if (viewToggle && previewColumn) {
        viewToggle.addEventListener('click', (e) => {
            e.preventDefault();
            previewColumn.classList.toggle('preview-dark-mode');
        });
    }

    // --- WARENKORB LOGIK ---
    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            const activeUploadField = getOrInitUploadLift();
            if (!activeUploadField) {
                alert("Das Upload-System lädt noch kurz. Bitte klicke in 2 Sekunden erneut auf 'Zum Warenkorb'.");
                return;
            }

            const loadingOverlay = document.getElementById('zebra-loading-overlay');
            const progressBar = document.getElementById('zebra-progress-bar');
            
            if (loadingOverlay) {
                loadingOverlay.style.display = 'flex';
                const loadingText = loadingOverlay.querySelector('.loading-text') || document.getElementById('zebra-loading-text');
                if (loadingText) loadingText.innerText = "Warenkorb wird vorbereitet..."; 
            }

            // FIX: Immer direkt aus inputWidth / inputHeight lesen statt aus lpoX!
            const finalW = inputWidth.value.replace('.', ',');
            const finalH = inputHeight.value.replace('.', ',');

            try {
                const blob = await getSafeBlob(canvas);
                if (progressBar) progressBar.style.width = '30%';
                
                const uploadedFile = await activeUploadField.uploadFile(blob);
                const imageUrl = uploadedFile.url;
                if (progressBar) progressBar.style.width = '60%';

                const lpoX = document.querySelector('input[name="properties[_Größe_x]"]');
                const lpoY = document.querySelector('input[name="properties[_Größe_y]"]');
                const lpoMotiv = document.querySelector('input[name="properties[Motiv]"]');
                const lpoQty = document.querySelector('input[name="quantity"]');

                if (lpoQty) {
                    lpoQty.value = parseInt(inputQty.value) || 1;
                    lpoQty.dispatchEvent(new Event('input', { bubbles: true }));
                    lpoQty.dispatchEvent(new Event('change', { bubbles: true }));
                }

                if (lpoX && lpoY) {
                    lpoX.value = finalW;
                    lpoY.value = finalH;
                    if (lpoMotiv) lpoMotiv.value = imageUrl;

                    [lpoX, lpoY, lpoMotiv].forEach(el => {
                        if (el) {
                            el.dispatchEvent(new Event('input', { bubbles: true }));
                            el.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });
                }

                if (progressBar) progressBar.style.width = '80%';
                await new Promise(resolve => setTimeout(resolve, 1200));

                const themeSubmitBtn = document.querySelector('form[action="/cart/add"] button[type="submit"].push-btn') || document.querySelector('form[action="/cart/add"] button[type="submit"]');
                const cartForm = document.querySelector('form[action="/cart/add"]');

                if (progressBar) progressBar.style.width = '100%';
                
                if (themeSubmitBtn) {
                    themeSubmitBtn.disabled = false;
                    themeSubmitBtn.classList.remove('loading', 'is-loading', 'disabled');
                    themeSubmitBtn.click();
                } else if (cartForm) {
                    cartForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }

                setTimeout(() => {
                    if (loadingOverlay) loadingOverlay.style.display = 'none';
                }, 2000);

            } catch (err) {
                console.error("Zebra Sync Error:", err);
                if (loadingOverlay) loadingOverlay.style.display = 'none';
                alert("Fehler beim Speichern. Bitte versuche es erneut.");
            }
        });
    }

    if (addAndResetBtn) {
        const originalButtonHtml = addAndResetBtn.innerHTML;

        addAndResetBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            const activeUploadField = getOrInitUploadLift();
            if (!activeUploadField || addAndResetBtn.dataset.loading === "true") return;

            addAndResetBtn.dataset.loading = "true";
            addAndResetBtn.style.opacity = "0.5";
            addAndResetBtn.querySelector('.mini-title').innerText = "Warenkorb wird vorbereitet...";

            const loadingOverlay = document.getElementById('zebra-loading-overlay');
            if (loadingOverlay) {
                loadingOverlay.style.display = 'flex';
                const loadingText = loadingOverlay.querySelector('.loading-text') || document.getElementById('zebra-loading-text');
                if (loadingText) loadingText.innerText = "Motiv wird gespeichert..."; 
            }

            try {
                const blob = await getSafeBlob(canvas);
                const progressBar = document.getElementById('zebra-progress-bar');
                if (progressBar) progressBar.style.width = '30%';
                
                const uploadedFile = await activeUploadField.uploadFile(blob);
                const imageUrl = uploadedFile.url;
                if (progressBar) progressBar.style.width = '60%';

                const lpoX = document.querySelector('input[name="properties[_Größe_x]"]');
                const lpoY = document.querySelector('input[name="properties[_Größe_y]"]');
                const lpoMotiv = document.querySelector('input[name="properties[Motiv]"]');
                const lpoQty = document.querySelector('input[name="quantity"]');

                if (lpoQty) {
                    lpoQty.value = parseInt(inputQty.value) || 1;
                    lpoQty.dispatchEvent(new Event('input', { bubbles: true }));
                    lpoQty.dispatchEvent(new Event('change', { bubbles: true }));
                }

                if (lpoX && lpoY) {
                    lpoX.value = inputWidth.value.replace('.', ',');
                    lpoY.value = inputHeight.value.replace('.', ',');
                    if (lpoMotiv) lpoMotiv.value = imageUrl;

                    [lpoX, lpoY, lpoMotiv].forEach(el => {
                        if (el) {
                            el.dispatchEvent(new Event('input', { bubbles: true }));
                            el.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });
                }

                if (progressBar) progressBar.style.width = '80%';
                await new Promise(resolve => setTimeout(resolve, 1000));
                document.body.classList.add('zebra-silent-mode');

                const themeSubmitBtn = document.querySelector('form[action="/cart/add"] button[type="submit"].push-btn') || document.querySelector('form[action="/cart/add"] button[type="submit"]');
                const cartForm = document.querySelector('form[action="/cart/add"]');

                if (progressBar) progressBar.style.width = '100%'; 

                if (themeSubmitBtn) {
                    themeSubmitBtn.disabled = false;
                    themeSubmitBtn.classList.remove('loading', 'is-loading', 'disabled');
                    themeSubmitBtn.click();
                } else if (cartForm) {
                    cartForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }

                await new Promise(resolve => setTimeout(resolve, 1500));

                if (window.Alpine && window.Alpine.store('modals')) {
                    window.Alpine.store('modals').close('rightDrawer');
                    window.Alpine.store('modals').close('cart');
                }

                document.body.classList.remove('zebra-silent-mode');

                configuratorState.style.display = 'none';
                uploadBox.style.display = 'flex';
                uploadBox.scrollIntoView({ behavior: 'auto', block: 'center' });
                
                const uploadText = uploadBox.querySelector('.upload-subtitle');
                if (uploadText) {
                    uploadBox.querySelector('.upload-title').innerText = "✅ Gespeichert!";
                    uploadText.innerHTML = `Erfolgreich zum Warenkorb hinzugefügt!<br>Wähle jetzt dein nächstes Motiv:`;
                }

                aiCache = { original: null, bgOnly: null, upOnly: null, both: null };
                fileInput.value = ''; 
                inputWidth.value = "8.0";
                inputQty.value = 1;
                if(qtyDisplay) qtyDisplay.innerText = "1";
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                
                addAndResetBtn.innerHTML = originalButtonHtml;
                addAndResetBtn.style.opacity = "1";
                addAndResetBtn.dataset.loading = "false";

                if (loadingOverlay) loadingOverlay.style.display = 'none';

            } catch (err) {
                console.error("Zebra Error:", err);
                document.body.classList.remove('zebra-silent-mode');
                addAndResetBtn.innerHTML = originalButtonHtml;
                addAndResetBtn.style.opacity = "1";
                addAndResetBtn.dataset.loading = "false";
                if (loadingOverlay) loadingOverlay.style.display = 'none';
                alert("Fehler beim Speichern.");
            }
        });
    }

});
})(); // Sicherheits-Käfig ENDE